export default function InscrieriGradinitaPage() {

  const documente = [
    { titlu: "Calendar etape reînscriere", fisier: "/educatie/inscrieriGradinita/CALENDAR ETAPE REINSCRIERE-INSCRIERE.pdf"},
    { titlu: "Locuri libere după etape de reînscriere", fisier: "/educatie/inscrieriGradinita/LOCURI LIBERE DUPĂ ETAPA DE REÎNSCRIERE 2026-2027.pdf" },
    { titlu: "Informații înscrieri grădiniță", fisier: "/educatie/inscrieriGradinita/Informații înscrieri grădiniță 2026-2027.pdf" },
    { titlu: "Învățământ preșcolar - plan școlarizare", fisier: "/educatie/inscrieriGradinita/ÎNVĂȚĂMÂNT PREȘCOLAR- PLAN ȘCOLARIZARE 2026-2027.pdf" },
    { titlu: "Documente dosar înscriere", fisier: "/educatie/inscrieriGradinita/DOCUMENTE DOSAR INSCRIERE.pdf"},
    { titlu: "Criterii generale însciere", fisier: "/educatie/inscrieriGradinita/CRITERII GENERALE INSCRIERE.pdf"} 
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-6">
            Înscrieri la grădiniță 2026-2027
          </h2>

          <ul className="space-y-3">
            {documente.map((doc, index) => (
              <li key={index}>
                <a
                  href={doc.fisier}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {doc.titlu}
                </a>
              </li>
            ))}
          </ul>

        </div>

      </main>
    </div>
  );
}